<template>
    <div>
        <!-- Component for tab navbar menu here -->
        <DashboardNavbar v-if="$route.name == 'billing_dashboard'" />
        <InvoicePageNavbar
            v-if="
                $route.name == 'invoice' ||
                $route.name == 'direct-url-billing-invoice-profile'
            "
        />
        <EstimatePageNavbar
            v-if="
                $route.name == 'estimate' ||
                $route.name == 'direct-url-billing-estimate-profile'
            "
        />
        <ReturnPageNavbar v-if="$route.name == 'return'" />
    </div>
</template>

<script>
import DashboardNavbar from "@/module/billing/navbar/dashboard.vue";
import InvoicePageNavbar from "@/module/billing/navbar/invoice.vue";
import EstimatePageNavbar from "@/module/billing/navbar/estimate.vue";
import ReturnPageNavbar from "@/module/billing/navbar/return.vue";
export default {
    components: {
        DashboardNavbar,
        InvoicePageNavbar,
        EstimatePageNavbar,
        ReturnPageNavbar
    }
};
</script>
